import type { StoreGiftCardRepository } from '../../domain/interfaces/StoreGiftCardRepository';
import type { GiftCardFormData } from '../../domain/models/storeGiftCard.types';

export class StoreGiftCardService {
  constructor(private repository: StoreGiftCardRepository) { }

  async fetchGiftCardConfig() {
    return this.repository.getGiftCardConfig();
  }

  async checkNddAvailability(pincode: string) {
    return this.repository.checkNddAvailability(pincode);
  }

  submitGiftCardOrder(formData: GiftCardFormData, customizationId: string) {
    this.repository.submitGiftCardOrder(formData, customizationId);
  }
}